import { WidgetType } from '@kemu-io/kemu-core/types';
import { WidgetCategory } from '../types/widgets';

export const WidgetCategoryMap: Record<WidgetType, WidgetCategory> = {
  // Consumers
  display: 'consumer',
  status: 'consumer',
  output: 'consumer',
  // action: 'consumer',

  // Transformers
  arrayCombine: 'transformer',
  objectCombine: 'transformer',
  arrayItem: 'transformer',
  extractImage: 'transformer',
  json: 'transformer',
  jsonParse: 'transformer',
  stringify: 'transformer',
  map: 'transformer',
  multiplication: 'transformer',
  parser: 'transformer',
  object: 'transformer',
  secret: 'transformer',

  // Image operations
  base64ToImageData: 'transformer',
  imageConvolution: 'transformer',
  imageCrop: 'transformer',
  imageResize: 'transformer',
  pixelDraw: 'transformer',
  imageWarp: 'transformer',
  counter: 'transformer',
  imageFilter: 'transformer',
  templateString: 'transformer',
  dataToBinaryFile: 'transformer',

  // Store data
  text: 'storage',
  value: 'storage',
  variable: 'storage',
  globalVariable: 'storage',
  fieldValue: 'storage',
  eventCache: 'storage',

  // Conditions
  between: 'condition',
  ifGate: 'condition',

  // Producers
  clock: 'producer',
  play: 'producer',
  input: 'producer',
  slider: 'producer',
  randomBetween: 'producer',
  recipeLoad: 'producer',

  // Logic
  elapsed: 'logic',
  firstEvent: 'logic',
  skipEvent: 'logic',
  suspend: 'logic',
  delay: 'logic',
  sequence: 'logic',
  rescue: 'logic',
  loop: 'logic',

  widgetGroup: 'custom',
  script: 'custom',
  hubService: 'custom',
  note: 'custom',
  expressionEval: 'custom',
  switch: 'condition',
  edgeFunction: 'custom',
};


export const getCategoryFromType = (type: WidgetType): WidgetCategory => {
	return WidgetCategoryMap[type] ?? 'custom';
};
